import { render, staticRenderFns } from "./LikeBtn.vue?vue&type=template&id=0f690890&scoped=true"
import script from "./LikeBtn.vue?vue&type=script&lang=js"
export * from "./LikeBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f690890",
  null
  
)

export default component.exports